// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"Welcome_paragraph__olIGi","lightbulb":"Welcome_lightbulb__2KjJM"};